// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"modalContainer-3aeeO","modalHeader":"modalHeader-1_UGG","modalBody":"modalBody-2-Kdj","modalButtons":"modalButtons-3BgYP","confirmButton":"confirmButton-1FeSN"};